
//点击日历日期
export const ALARM_CHOOSETYPE_CLICK_MONTH_DATE='ALARM/CHOOSETYPE/CLICK_MONTH_DATE';
//点击选择报警类型
export const ALARM_CHOOSETYPE_FAILURE_TYPE_ID='ALARM/CHOOSETYPE/FAILURE_TYPE_ID';
